import React, {useState} from 'react'
import {useHistory} from "react-router-dom"
import "./enteral.css";
import Header from "./Header"
import Footer from "./Footer"
import FeedingRate from './FeedingRate';
import { Icon, InlineIcon } from '@iconify/react';
import calculatorIcon from '@iconify-icons/entypo/calculator';
import { round } from 'mathjs' 

function FeedingFreq() {
    let history = useHistory();

    const [selectBMilk, setSelectBmilk] = useState(false)
    const [selectP22, setSelectP22] = useState(false)
    const [selectP24, setSelectP24] = useState(false)

    const [selectBMilk2, setSelectBmilk2] = useState(false)
    const [selectP22f2, setSelectP22f2] = useState(false)
    const [selectP24f2, setSelectP24f2] = useState(false)

    const [selectNo, setSelectNo] = useState(false)
    const [selectR25, setSelectR25] = useState(false)
    const [selectR50, setSelectR50] = useState(false)

    const [selectNo2, setSelectNo2] = useState(false)
    const [selectR25f2, setSelectR25f2] = useState(false)
    const [selectR50f2, setSelectR50f2] = useState(false)

    const [volume, setVolume] = useState("");
    const [frequency, setFrequency] = useState("");
    const [volume2, setVolume2] = useState("");
    const [frequency2, setFrequency2] = useState("");
    const [whey, setWhey] = useState("")

    const [bmilk, setBmilk] =  useState("");
    const [p22, setP22] = useState("");
    const [p24, setP24] = useState("");
    const [no, setNo] = useState("");
    const [ratio25, setRatio25] = useState("");
    const [ratio50, setRatio50] = useState("");

    const [bmilkf2, setBmilkf2] =  useState("");
    const [p22f2, setP22f2] = useState("");
    const [p24f2, setP24f2] = useState("");
    const [nof2, setNof2] = useState("");
    const [ratio25f2, setRatio25f2] = useState("");
    const [ratio50f2, setRatio50f2] = useState("");
    
    var weight = localStorage.getItem("current weight")

    var weightCalc = parseFloat(weight)    
    var weightCalc1 = weightCalc.toFixed(2)

    var totalfeed1 = (frequency * volume)
    var totalfeed2 = (frequency2 * volume2)
    
    var totalVolC = (+totalfeed1  + +totalfeed2)
    var totalVol = totalVolC.toFixed(1)

    var wheyproteinE = round(whey * 4.15 * weight,2)
    localStorage.setItem("wheyproteinE",wheyproteinE)
    var wheyproteinP = round(whey * 0.798 * weight,2)
    localStorage.setItem("wheyproteinP",wheyproteinP)

    const calculate = () => {
        console.log("calculate")
        history.push("/calculate-feeding")
    }

    const handleVolume = (event) => {
        setVolume(event.target.value);
        localStorage.setItem("volume feed 1", event.target.value);
        console.log("volume1 from event:", event.target.value);
      };

      const handleFrequency = (event) => {
        setFrequency(event.target.value);
        localStorage.setItem("frequency feed 1", event.target.value);
        console.log("frequency1 from event:", event.target.value);
      };

      const handleVolume2 = (event) => {
        setVolume2(event.target.value);
        localStorage.setItem("volume feed 2", event.target.value);
        console.log("volume2 from event:", event.target.value);
      };

      const handleFrequency2 = (event) => {
        setFrequency2(event.target.value);
        localStorage.setItem("frequency feed 2", event.target.value);
        console.log("frequency2 from event:", event.target.value);
      };

      const handleWhey = (event) => {
        setWhey(event.target.value);
        localStorage.setItem("whey protein", event.target.value);
        console.log("weight from event:", event.target.value);
      };

      const handleBmilk = (event) => {
        setBmilk(event.target.value);
        setSelectBmilk(true)
        setSelectP22(false)
        setSelectP24(false)
        localStorage.setItem("Type of feed", "Breastmilk");
        var feedE1 = round(totalfeed1 * 0.75,2)
        localStorage.setItem("feedE1" , feedE1)
        var feedP1 = round(totalfeed1 * 0.013,2)
        localStorage.setItem("feedP1" , feedP1)
      }

      const handleP22 =(event) => {
        setP22(event.target.value);
        setSelectBmilk(false)
        setSelectP22(true)
        setSelectP24(false)
        localStorage.setItem("Type of feed", "P22");
        var feedE1 = round(totalfeed1 * 0.74,2)
        localStorage.setItem("feedE1" , feedE1)
        var feedP1 = round(totalfeed1 * 0.021,2)
        localStorage.setItem("feedP1" , feedP1)
      }

      const handleP24 = (event) => {
        setP24(event.target.value);
        setSelectBmilk(false)
        setSelectP22(false)
        setSelectP24(true)
        localStorage.setItem("Type of feed", "P24");
        var feedE1 = round(totalfeed1 * 0.81,2)
        localStorage.setItem("feedE1" , feedE1)
        var feedP1 = round(totalfeed1 * 0.024,2)
        localStorage.setItem("feedP1" , feedP1)
      }

      const handleNo = (event) => {
        setNo(event.target.value);
        setSelectNo(true)
        setSelectR25(false)
        setSelectR50(false)
        localStorage.setItem("HMF", "No");
        var hmfE1 = totalfeed1 * 0
        localStorage.setItem("hmfE1" , hmfE1)
        var hmfP1 = totalfeed1 * 0
        localStorage.setItem("hmfP1" , hmfP1)
      }

      const handleRatio25 = (event) => {
        setRatio25(event.target.value);
        setSelectNo(false)
        setSelectR25(true)
        setSelectR50(false)
        localStorage.setItem("HMF", "1:25");
            var hmfE1 = round(totalfeed1 * 0.14,2)
          localStorage.setItem("hmfE1" , hmfE1)
           var hmfP1 = totalfeed1 * 0.01
        localStorage.setItem("hmfP1" , hmfP1)
      }

      const handleRatio50 = (event) => {
        setRatio50(event.target.value);
        setSelectNo(false)
        setSelectR25(false)
        setSelectR50(true)
        localStorage.setItem("HMF", "1:50");
            var hmfE1 = round(totalfeed1 * 0.07,2)
        localStorage.setItem("hmfE1" , hmfE1)
         var hmfP1 = round(totalfeed1 * 0.05,2)
        localStorage.setItem("hmfP1" , hmfP1)
      }

      const handleBmilkf2 = (event) => {
        setBmilkf2(event.target.value);
        setSelectBmilk2(true)
        setSelectP22f2(false)
        setSelectP24f2(false)
        localStorage.setItem("Type of feed 2", "Breastmilk");
         var feedE2 = round(totalfeed2 * 0.75,2)
        localStorage.setItem("feedE2" , feedE2)
         var feedP2 = round(totalfeed2 * 0.013,2)
        localStorage.setItem("feedP2" , feedP2)
      }

      const handleP22f2 =(event) => {
        setP22f2(event.target.value);
        setSelectBmilk2(false)
        setSelectP22f2(true)
        setSelectP24f2(false)
        localStorage.setItem("Type of feed 2", "P22");
        var feedE2 = round(totalfeed2 * 0.74,2)
        localStorage.setItem("feedE2" , feedE2)
         var feedP2 = round(totalfeed2 * 0.021,2)
        localStorage.setItem("feedP2" , feedP2)
      }

      const handleP24f2 = (event) => {
        setP24f2(event.target.value);
        setSelectBmilk2(false)
        setSelectP22f2(false)
        setSelectP24f2(true)
        localStorage.setItem("Type of feed 2", "P24");
        var feedE2 = round(totalfeed2 * 0.81,2)
        localStorage.setItem("feedE2" , feedE2)
         var feedP2 = round(totalfeed2 * 0.024,2)
        localStorage.setItem("feedP2" , feedP2)
      }

      const handleNof2 = (event) => {
        setNo(event.target.value);
        setSelectNo2(true)
        setSelectR25f2(false)
        setSelectR50f2(false)
        localStorage.setItem("HMF 2", "No");
        var hmfE2 = totalfeed2 * 0
        localStorage.setItem("hmfE2" , hmfE2)
        var hmfP2 = totalfeed2 * 0
        localStorage.setItem("hmfP2" , hmfP2)
      }

      const handleRatio25f2 = (event) => {
        setRatio25f2(event.target.value);
        setSelectNo2(false)
        setSelectR25f2(true)
        setSelectR50f2(false)
        localStorage.setItem("HMF 2", "1:25");
        var hmfE2 = round(totalfeed2 * 0.14,2)
        localStorage.setItem("hmfE2" , hmfE2)
        var hmfP2 = round(totalfeed2 * 0.01,2)
        localStorage.setItem("hmfP2" , hmfP2)
      }

      const handleRatio50f2 = (event) => {
        setRatio50f2(event.target.value);
        setSelectNo2(false)
        setSelectR25f2(false)
        setSelectR50f2(true)
        localStorage.setItem("HMF 2", "1:50");
        var hmfE2 = round(totalfeed2 * 0.07,2)
        localStorage.setItem("hmfE2" , hmfE2)
        var hmfP2 = round(totalfeed2 * 0.005,2)
        localStorage.setItem("hmfP2" , hmfP2)
      }

      //total feedEnergy
      var feedE11 = localStorage.getItem("feedE1")
      var feedE22 = localStorage.getItem("feedE2")
      var hmfE11 = localStorage.getItem("hmfE1")
      var hmfE22 = localStorage.getItem("hmfE2")
      var feedE = ((+feedE11 + +feedE22) * weight)
      var hmfE = ((+hmfE11 + +hmfE22) * weight)
      localStorage.setItem("feedE", feedE)
      localStorage.setItem("hmfE", hmfE)

      //total feedProtein ==> this left
      var feedP11 = localStorage.getItem("feedP1")
      var feedP22 = localStorage.getItem("feedP2")
      var hmfP11 = localStorage.getItem("hmfP1")
      var hmfP22 = localStorage.getItem("hmfP2")
      var feedP = ((+feedP11 + +feedP22) * weight)
      var hmfP =  ((+hmfP11 + +hmfP22) * weight) 
      localStorage.setItem("feedP", feedP)
      localStorage.setItem("hmfP", hmfP)

    return (
        <div className="row">
        <div className="col-md-12">
        <div className= "enteral__page">
        <Header/>
        <div className="enteral__content">
          <div className = "font__smaller">
        <form onSubmit= {calculate}>            
            <label><strong>Please insert information into the empty cells</strong></label>
                <div className = "to__bottom">
                <p><strong>Feed 1</strong></p>
                </div>
                <div className="push__totop"> 
                <label><strong>Feeds per session (ml)</strong>  <input step="any" required  value ={volume} onChange = {handleVolume} className = "volandfreq__input" size="7" type = "number"  pattern = "^(\d*\.)?\d+$" placeholder = "0"/></label>
                <label><strong>Frequency </strong>  <input step="any" required  value ={frequency} onChange = {handleFrequency} className = "volandfreq__input1" size="7" type = "number"  pattern = "^(\d*\.)?\d+$" placeholder = "0"/></label>
                <div className = "type__of__feed">
                <label><strong>Type of feed</strong></label>
                    <p>
                        <span onClick = {handleBmilk} value ={bmilk} className  = {selectBMilk ? "breastmilk__select1" : "breastmilk__select"}>
                            <div className = "breastmilk__word">Breastmilk</div>
                        </span> 
                        <span  onClick = {handleP22} value ={p22} className  = {selectP22 ? "breastmilk__select1" : "breastmilk__select"}>
                        <div className = "breastmilk__word">P22</div>
                            </span>
                         <span onClick = {handleP24} value ={p24} className  = {selectP24 ? "breastmilk__select1" : "breastmilk__select"}>
                         <div className = "breastmilk__word">P24</div>
                             </span>
                    </p>
                    </div>
                    <label> <strong>HMF</strong> </label>
                        <p> 
                            <span onClick = {handleNo} value ={no} className = {selectNo ? "hmf__select1" : "hmf__select"}>
                                <div className = "breastmilk__word">NO</div>
                                </span>
                                 <span onClick = {handleRatio25} value ={ratio25} className = {selectR25 ? "hmf__select1" : "hmf__select"}>
                                 <div className = "breastmilk__word">1:25</div>
                                     </span> 
                            <span onClick = {handleRatio50} value ={ratio50} className = {selectR50 ? "hmf__select1" : "hmf__select"}>
                            <div className = "breastmilk__word">1:50</div>
                                </span>
                        </p>
                 </div>
            <div className = "type__of__feed2">
              <div className = "to__bottom">
                <p><strong>Feed 2</strong></p>
                </div>
                <div className = "push__totop">
                <label><strong>Feeds per session (ml)</strong>  <input step="any" required value ={volume2} onChange = {handleVolume2} className = "volandfreq__input" size="7" type = "number"  pattern = "^(\d*\.)?\d+$" placeholder = "0"/></label>
                <label><strong>Frequency </strong>  <input  step="any" required value ={frequency2} onChange = {handleFrequency2} className = "volandfreq__input1" size="7" type = "number"  pattern = "^(\d*\.)?\d+$" placeholder = "0"/></label>
            </div>
            <div className = "type__of__feed2">
            <label><strong>Type of feed</strong></label>
                    <p>
                        <span onClick = {handleBmilkf2} value ={bmilkf2} className  = {selectBMilk2 ? "breastmilk__select1" : "breastmilk__select"}>
                            <div className = "breastmilk__word">Breastmilk</div>
                        </span> 
                        <span onClick = {handleP22f2} value ={p22f2} className  = {selectP22f2 ? "breastmilk__select1" : "breastmilk__select"}>
                        <div className = "breastmilk__word">P22</div>
                            </span>
                         <span onClick = {handleP24f2} value ={p24f2} className  = {selectP24f2 ? "breastmilk__select1" : "breastmilk__select"}>
                         <div className = "breastmilk__word">P24</div>
                             </span>
                    </p>
                    <label> <strong>HMF</strong> </label>
                        <p> 
                            <span onClick = {handleNof2} value ={nof2} className = {selectNo2 ? "hmf__select1" : "hmf__select"}>
                                <div className = "breastmilk__word">NO</div>
                                </span>
                                 <span onClick = {handleRatio25f2} value ={ratio25f2} className = {selectR25f2? "hmf__select1" : "hmf__select"}>
                                 <div className = "breastmilk__word">1:25</div>
                                     </span> 
                            <span onClick = {handleRatio50f2} value ={ratio50f2} className = {selectR50f2 ? "hmf__select1" : "hmf__select"}>
                            <div className = "breastmilk__word">1:50</div>
                                </span>
                        </p>
                        <label><strong>Whey Protein (g/day)</strong> <input step="any" required className = "whey__protein__FR"value = {whey} onChange={handleWhey} size="7" type = "number"  pattern = "^(\d*\.)?\d+$" placeholder="0.0"/></label>
            </div>
            <div>
            <label><strong>Total Volume of Feeds (ml)</strong> <div className = "total__volumefeed">{totalVol}</div></label>
            </div>
            </div>
            <button className = "calculate__feedfreq" onSubmit = {calculate}>
            <Icon icon={calculatorIcon} />Calculate
            </button>
            </form>
            </div>
            </div>
             </div>
            </div>
        </div>
    )
}

export default FeedingFreq
